import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useTipoEtiqueta = () => {
  const [tipoEtiqueta, setTipoEtiqueta] = useState([]);
  const getTipoEtiqueta = async () => {
    try {
      const response = await api.get("api/etiquetas/obtener/all-tipo-etiqueta");
      setTipoEtiqueta(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTipoEtiqueta();
  }, []);

  return { getTipoEtiqueta, tipoEtiqueta };
};
